export interface MappingInjectionMoldingProductVersionToQualityAlert {
    id: string;
    productVersionId: string;
    qualityAlertId: string;
    /** Blank disables progress-based checks for this alert on this product version. */
    checkIntervalPercent?: number | null;
}

export function isValidInjectionMoldingQualityCheckInterval(
    value: number | null | undefined,
): boolean {
    return value == null || (Number.isSafeInteger(value) && value >= 1 && value <= 99);
}

/** Order-progress percentages at which a quality check comes due; never includes 100%. */
export function injectionMoldingQualityCheckMilestones(
    checkIntervalPercent: number | null | undefined,
): number[] {
    if (checkIntervalPercent == null || !isValidInjectionMoldingQualityCheckInterval(checkIntervalPercent)) {
        return [];
    }
    const milestones: number[] = [];
    for (let percent = checkIntervalPercent; percent < 100; percent += checkIntervalPercent) {
        milestones.push(percent);
    }
    return milestones;
}

/** Short human description of when checks come due, e.g. "due at 25%, 50% and 75% of each order". */
export function describeInjectionMoldingQualityCheckSchedule(
    checkIntervalPercent: number | null | undefined,
): string {
    if (checkIntervalPercent == null) {
        return 'no checks during the order';
    }
    if (!isValidInjectionMoldingQualityCheckInterval(checkIntervalPercent)) {
        return 'enter a whole number from 1 to 99';
    }
    const milestones = injectionMoldingQualityCheckMilestones(checkIntervalPercent);
    if (milestones.length > 5) {
        return `${milestones.length} checks per order, every ${checkIntervalPercent}%`;
    }
    const labels = milestones.map((percent) => `${percent}%`);
    const list = labels.length === 1
        ? labels[0]
        : `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`;
    return `due at ${list} of each order`;
}
